import { type ReactNode } from "react";
import { TableCell, useTheme } from "@mui/material";

import type { IncidentTableRow } from "../types.js";

/**
 * The cell which renders the dynamic data.
 */
export function DataCell({
  row,
  columnId,
  children,
}: {
  row: IncidentTableRow;
  columnId: string;
  children: ReactNode;
}) {
  const theme = useTheme();

  return (
    <TableCell
      sx={{
        border: `1px solid`,
        borderColor: row.isPendingTransfer
          ? theme.palette.warning.main
          : theme.palette.grey[300],
        borderWidth: row.isPendingTransfer ? 2 : 1,
        ...(columnId === "actions" && {
          textAlign: "right",
          whiteSpace: "nowrap",
        }),
      }}
    >
      {children}
    </TableCell>
  );
}
